class Timer {
  constructor(timeout, callback) {
    this.timeout = timeout;
    this.callback = callback;

    this.intervalObject = null;
    this.isPlaying = false;
  }

  play() {
    this.isPlaying = true;
    this.intervalObject = setInterval(() => {
      this.callback();
    }, this.timeout);
  }

  stop() {
    this.isPlaying = false;
    clearInterval(this.intervalObject);
  }
}

export default Timer;
